import React from 'react';
import { Button, Form } from "react-bootstrap";

const AddressInformationStep = ({ activeStep, setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Address Information</h5>

                            <div className="row">
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Street Address:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Street Address" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Appt Number:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Appt Number" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>City:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter City" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>State:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter State" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Zip Code:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Zip Code" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Metro Area:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Metro Area" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-12 mt-5">
                                    <div className="row justify-content-between">
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(pre => pre - 1)}
                                            >
                                                Previous
                                            </Button>
                                        </div>
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(pre => pre + 1)}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddressInformationStep;